import axios from "axios";

const web = axios.create({
    baseURL : process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL, 
    //withCredentials : true,
    headers: {
        "Content-Type" : "application/json"
    }
});


export default web